module.exports = __webpack_public_path__ + "images/laptop.62af2b787ee48c3e39f48555c6d900f3.png";